const clientReport = {
  clientReports: 'Отчет клиента',
  showing: 'показывается',
  clientReportsOf: 'клиенты',
  noClientReportsFound: 'Отчеты клиентов не найдены',
};

export default clientReport;
